import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'

import { LoadingSpinner } from './components/common/LoadingSpinner';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';

// Lazy load all page components
const Home = React.lazy(() => import('./pages/Home').then(module => ({ default: module.default })));
const Fleet = React.lazy(() => import('./pages/Fleet').then(module => ({ default: module.default })));
const About = React.lazy(() => import('./pages/About').then(module => ({ default: module.default })));
const Contact = React.lazy(() => import('./pages/Contact').then(module => ({ default: module.default })));
const Booking = React.lazy(() => import('./pages/Booking').then(module => ({ default: module.default })));
const FAQ = React.lazy(() => import('./pages/FAQ').then(module => ({ default: module.default })));

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// RouteChangeHandler component
function RouteChangeHandler({ setIsLoading }) {
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const startTimeout = setTimeout(() => {
      if (isMounted) setIsLoading(true);
    }, 10);
    const stopTimeout = setTimeout(() => {
      if (isMounted) setIsLoading(false);
    }, 500);
    return () => {
      isMounted = false;
      clearTimeout(startTimeout);
      clearTimeout(stopTimeout);
      setIsLoading(false);
    };
  }, [location, setIsLoading]);
  return null;
}

// Main App component
function AppContent({ setIsLoading }) {
  
  const handleNavLinkClick = () => {
    const isMobileOrSmallWindow = /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 992;
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (isMobileOrSmallWindow && navbarCollapse) {
      const isOpen = navbarCollapse.classList.contains('show');
      if (isOpen) {
        const bsCollapse = new bootstrap.Collapse(navbarCollapse);
        bsCollapse.hide();
      }
    }
  };

  return (
    <>
      <ScrollToTop />
      <RouteChangeHandler setIsLoading={setIsLoading} />
      <Header handleNavLinkClick={handleNavLinkClick} />
      <main>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fleet" element={<Fleet />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="*" element={
              <div className="container py-5 text-center">
                <h1>404 - Page Not Found</h1>
                <p>The page you are looking for does not exist.</p>
              </div>
            } />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

// Root App component
function App() {
  const [isLoading, setIsLoading] = useState(false);
  // const getBasename = () => {
  //   const isLocalhost = window.location.hostname === 'localhost' || 
  //                      window.location.hostname === '127.0.0.1';
    
  //   // Use empty string for localhost, '/fancyfleet' for production
  //   return isLocalhost ? '' : '/fancyfleet';
  // };
  return (
    <HelmetProvider>
      <BrowserRouter>
        {isLoading && <LoadingSpinner />}
        <AppContent setIsLoading={setIsLoading} />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;